export default {
  // baseUrl: 'http://192.168.31.164:8080/gateway',
  // baseUrl: 'https://servicestest.mtnsyr.com:16060',
  baseUrl: 'https://imtn.mtnsyr.com:16060',
  // baseUrl: 'https://10.11.119.97:8443/gateway',
  // baseUrl: 'https://servicestest.mtnsyr.com:9875/gateway',
  // baseUrl: 'https://servicestest.mtnsyr.com:59681/gateway',
  // baseUrl: 'http://localhost:8761',
  // baseUrl: 'https://services.mtnsyr.com:6384/gateway',
  // baseUrl: 'http://192.168.31.141:8091',
  // website: 'https://servicestest.mtnsyr.com:1414/Website'
  website: 'http://localhost:8080'
}
